import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a987861e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a987861e&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=a987861e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a987861e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Empty: require('/drone/src/components/Empty/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default})
